import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  PaperClipOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import {
  Form,
  Input,
  Table,
  Collapse as AntCollapse,
  Descriptions,
  Modal as AntModal,
  Spin,
  Flex,
  Select,
  InputNumber,
  Empty,
  Modal,
} from "antd";
import {
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
} from "../../components/Component";
import dayjs from "dayjs";
import {
  Button,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Spinner,
} from "reactstrap";
import { nanoid } from "nanoid";
import Swal from "sweetalert2";
import usersApis from "../../api/master/users";
import dispatchApis from "../../api/dispatch/dispatch";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { fetchSequenceAccess } from "../../store/slices/misc/sequenceAccess";
import { formatCurrency, formatDecimal } from "../../utils/Utils";
import PdfGenerator from "./SellerToBuyerDispatchPDF";
import axios from "axios";
import { TimePicker } from "antd";
import miscService from "../../api/misc/misc";
import EmailCreationModal from "../EmailCreationModal";
import { useForm } from "react-hook-form";
import CropperComponent from "../components/CropperComponent";
import SignatureModal from "../purchase-orders/SignatureModal";
// import { _ } from "ag-grid-community";

const { Panel } = AntCollapse;
function DispatchComponent({ dispatchNumber, previousPath, extra }: any) {
  const pdfBlobData: any = useRef(null);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [shareOptionsToggle, setShareOptionsToggle] = useState(false);
  const { data: currentUser } = useSelector((state: any) => state.currentUser);
  const [disableAccept, setDisableAccept] = useState(false);
  const dispatch: any = useDispatch();
  const { data: sequenceAccess } = useSelector(
    (state: any) => state.sequenceAccess
  );
  const navigate = useNavigate();
  const [showSubmitBtn, setShowSubmitBtn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [tab, setTab] = useState("1");
  const [OriginalData, setOriginalData] = useState<any>({});
  const [screenSize, setScreenSize] = useState(0);
  const [mobileView, setMobileView] = useState(false);
  const [sm, setSm] = useState(false);
  const [materialData, setMaterialData] = useState<any>({});
  const [signature, setSignature] = useState<any>([]);
  const [bankDetailsVisible, setBankDetailsVisible] = useState(false);
  const [termsAndConditions, setTermsAndConditions] = useState<any>("");
  const [dataSource, setDataSource] = useState<any>([]);
  const [currency, setCurrency] = useState<any>({
    currencyFormat: "",
    currencySymbol: "",
  });
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [readOnly, setReadOnly] = useState<any>(true);
  const [currentUserId, setCurrentUserId] = useState<any>(null);
  const [attachments, setAttachments] = useState<any>([]);
  const [showCropModel, setShowCropModel] = useState<boolean>(false);
  const [showSignatureModel, setShowSignatureModel] = useState<boolean>(false);
  const [invoiceSignature, setInvoiceSignature] = useState<any>({});
  const methods = useForm({
    mode: "onChange",
  });
  const {
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = methods;
  useEffect(() => {
    dispatch(fetchSequenceAccess());
  }, [dispatch]);

  useEffect(() => {
    if (isModalVisible == false) {
      setDisableAccept(false);
    }
  }, [isModalVisible]);

  const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  }: any) => {
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex + `_${record.lineNo}`}
            style={{ margin: 0 }}
            rules={[
              {
                required: true,
                message: `${title} is required`,
              },
              {
                type: "number",
                min: 0.01,
                max: Number(record?.quantityDispatched),
                message: `${title} must be > 0 and <= ${Number(
                  record?.quantityDispatched
                )}`,
              },
            ]}
            initialValue={Number(record["quantityDispatched"])}
          >
            <InputNumber
              defaultValue={Number(record["quantityDispatched"])}
              className="w-100"
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value: any) => value!.replace(/\$\s?|(,*)/g, "")}
              onKeyPress={(event) => {
                const regex = /^[0-9\b\.]+$/;
                if (!regex.test(event.key)) {
                  event.preventDefault();
                }
              }}
              step={0.01}
            />
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  const columns = [
    {
      title: "#",
      key: "#",
      width: 50,
      fixed: "left",
      render: (text: any, record: any, index: number) => index + 1,
    },
    {
      title: "Material Name",
      dataIndex: "materialName",
      key: "materialName",
      width: 200,
      fixed: "left",
      render: (material: any) => <div className="align-left">{material}</div>,
    },
    {
      title: "Need By Date",
      dataIndex: "needByDate",
      key: "needByDate",
      width: 150,
      render: (text: any) => dayjs(text).format("DD-MMM-YYYY"),
    },
    {
      title: "Dispatched Qty",
      dataIndex: "quantityDispatched",
      key: "quantityDispatched",
      width: 150,
      render: (text: any, record: any) => (
        <div className="align-left">{Number(text) + " " + record?.uom}</div>
      ),
    },
    {
      title: "Received Qty",
      dataIndex: "recievedQuantity",
      key: "recievedQuantity",
      width: 150,
      editable: true,
      hidden: false,
    },
    {
      title: "GRN Qty",
      dataIndex: "grnQuantity",
      key: "grnQuantity",
      width: 150,
      render: (text: any, record: any) => (
        <div className="align-left">{Number(text) + " " + record?.uom}</div>
      ),
      hidden: true,
    },
    {
      title: "Rate",
      dataIndex: "unitPrice",
      key: "unitPrice",
      width: 150,
      render: (text: any, record: any) => (
        <p className="justify-end">
          {formatCurrency(Number(text), currency?.currencyCode)}
        </p>
      ),
    },
    {
      title: "Basic Amount",
      dataIndex: "basicAmount",
      key: "basicAmount",
      width: 150,
      render: (text: any) => <div>{text}</div>,
    },
    {
      title: "Net Amount",
      dataIndex: "netAmount",
      key: "netAmount",
      width: 150,
      render: (text: any) => <div>{text}</div>,
    },
    {
      title: "CGST",
      children: [
        {
          title: "%",
          dataIndex: "cgstPercentage",
          key: "cgstPercentage",
          width: 100,
          render: (text: any, record: any) =>
            `${Number(record?.sgst) && Number(record?.cgst)
              ? Number(text) + "%"
              : "N/A"
            }`,
        },
        {
          title: "Amount",
          dataIndex: "cgst",
          key: "cgst",
          width: 150,
          render: (text: any, record: any) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {Number(record?.sgst) && Number(record?.cgst)
                  ? formatCurrency(text, "INR")
                  : "N/A"}
              </span>
            </div>
          ),
        },
      ],
    },
    {
      title: "SGST",
      children: [
        {
          title: "%",
          dataIndex: "sgstPercentage",
          key: "sgstPercentage",
          width: 100,
          render: (text: any, record: any) =>
            `${Number(record?.sgst) && Number(record?.cgst)
              ? Number(text) + "%"
              : "N/A"
            }`,
        },
        {
          title: "Amount",
          dataIndex: "sgst",
          key: "sgst",
          width: 150,
          render: (text: any, record: any) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {Number(record?.sgst) && Number(record?.cgst)
                  ? formatCurrency(text, "INR")
                  : "N/A"}
              </span>
            </div>
          ),
        },
      ],
    },
    {
      title: "IGST",
      children: [
        {
          title: "%",
          dataIndex: "igstPercentage",
          key: "igstPercentage",
          width: 100,
          render: (text: any, record: any) =>
            `${!Number(record?.sgst) && !Number(record?.cgst)
              ? Number(text) + "%"
              : "N/A"
            }`,
        },
        {
          title: "Amount",
          dataIndex: "igst",
          key: "igst",
          width: 150,
          render: (text: any, record: any) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {!Number(record?.sgst) && !Number(record?.cgst)
                  ? formatCurrency(text, "INR")
                  : "N/A"}
              </span>
            </div>
          ),
        },
      ],
    },
    {
      title: "Gross Total",
      dataIndex: "grossTotal",
      key: "grossTotal",
      width: 150,
      render: (text: any) => <div>{text}</div>,
    },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status",
    //   width: 150,
    //   fixed: "right",
    //   render: (status: any) => {
    //     const _status = statusMapper[status]?.buyer;
    //     return (
    //       <div className="justify-start align-center">
    //         <h6
    //           className={`tb-status ms-1`}
    //           style={{
    //             color: `${_status?.color}`,
    //             fontSize: "14px",
    //           }}
    //         >
    //           {_status?.icon} {_status?.title || status}
    //         </h6>
    //       </div>
    //     );
    //   },
    // },
  ];

  const mergedColumns: any = columns.map((col) => {
    if (
      ["basicAmount", "netAmount", "additionalCharges", "grossTotal"].includes(
        col?.dataIndex as string
      )
    ) {
      return {
        ...col,
        render: (text: any) => (
          <p className="justify-end">
            {formatCurrency(Number(text), currency?.currencyCode)}
          </p>
        ),
      };
    } else if ((col.children?.length as number) > 0) {
      return {
        ...col,
        // children: col?.children?.map((child: any) => {
        //   if (child?.title == "Amount") {
        //     return {
        //       ...child,
        //       render: (text: any) => (
        //         <p className="justify-end">
        //           {formatCurrency(
        //             Number(text),
        //             currency?.currencyCode
        //           )}
        //         </p>
        //       ),
        //     };
        //   } else {
        //     return child;
        //   }
        // }),
      };
    }
    if (
      materialData?.needByDateType != "Line Level" &&
      col?.dataIndex == "needByDate"
    ) {
      return {
        ...col,
        hidden: true,
      };
    }
    if (OriginalData?.grnStatus == "Accepted") {
      if (col?.dataIndex == "recievedQuantity") {
        return {
          ...col,
          editable: false,
          hidden: true,
        };
      } else if (col?.dataIndex == "grnQuantity") {
        return {
          ...col,
          hidden: false,
        };
      }
    }
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record: any) => ({
        record,
        inputType: "number",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: OriginalData?.grnStatus == "Pending" ? true : false,
      }),
    };
  });

  const fetchCurrentUser = async () => {
    try {
      const data = await usersApis.getCurrentUser();
      if (data) {
        setCurrentUserId(data?.id);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const viewChange = () => {
    setScreenSize(window.innerWidth);
    if (window.innerWidth < 990) {
      setMobileView(true);
    } else {
      setMobileView(false);
      setSm(false);
    }
  };

  const TriggerEmail = async (emailData: any, _methods: any) => {
    try {
      const formData = new FormData();
      formData.append("msgType", "grnConfirmation");
      formData.append("logo", currentUser?.orgLogo);
      formData.append("email", emailData?.to);
      formData.append("cc", emailData?.cc);
      formData.append("bcc", emailData?.bcc);
      if (emailData?.attachments?.length > 0) {
        emailData?.attachments?.forEach((attachment: any, index: number) => {
          if (!attachment) {
            return;
          }
          let file: any = null;
          if (index == 0) {
            file = new File(
              [pdfBlobData.current],
              OriginalData?.dispatchId + ".pdf",
              {
                type: "application/pdf",
              }
            );
          } else {
            file = attachment?.originFileObj;
          }
          formData.append(`files`, file);
        });
      }
      const response: any = await dispatchApis.sendGrnEmailNotification(
        dispatchNumber,
        formData
      );
      const { data, status } = response;
      if (status) {
        Swal.fire("Success", "Email has been sent successfully", "success");
        _methods.reset();
        setShowEmailModal(false);
      }
    } catch (error) {
      console.log(error);
      setShowEmailModal(false);
    }
  };

  const fetchDispatchData = async () => {
    try {
      const response = await dispatchApis.fetchDispatch(dispatchNumber);
      const { status, message, data } = response;
      if (status) {
        if (data?.lineItems) {
          setDataSource(data?.lineItems);
        }
        if (data?.dms?.length > 0) {
          const dms = data?.dms;
          const _signature = dms?.find(
            (item: any) =>
              item.moduleFileType == "signature" && item.module == "grn"
          );
          if (_signature) {
            setSignature({
              docId: _signature?.docId,
              fileName: _signature?.fileName,
              image: _signature?.filePath,
              moduleFileType: _signature?.moduleFileType,
              module: _signature?.module,
              label: data?.grnSignatureLabel,
              isActive: true,
            });
          }
          const _attachments = dms?.filter(
            (item: any) => item.moduleFileType == "attachment"
          );
          if (_attachments) {
            setAttachments(
              _attachments.map((attachment: any) => ({
                docId: attachment?.docId,
                name: attachment?.fileName,
                link: attachment?.filePath,
                moduleFileType: attachment?.moduleFileType,
                module: attachment?.module,
                label: "attachment",
                isActive: true,
              }))
            );
          }
        }
        setCurrency({
          currencyCode: data?.currencyCode,
          currency: data?.currencyName,
          currencySymbol: data?.currencySymbol,
          currencyFormat: data?.currencyFormat,
        });
        if (
          [
            "Pending Approval",
            "Approval Rejected",
            "To be Dispatched",
            "Partially Dispatched",
          ].includes(data.invoiceStatus) &&
          data?.invoiceType != "commercial"
        ) {
          setReadOnly(false);
        } else {
          setReadOnly(true);
        }
        setMaterialData(data);
        setOriginalData(data);
        setShowSubmitBtn(false);
        setIsLoading(false);
        await fetchDMSData("buyerOrgLogo", data?.orgId);
        await fetchDMSData("sellerOrgLogo", data?.supplierId);
        await fetchDMSData("termsAndConditions", data?.invoiceNumber);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchHtmlContentFromUrl = async (url: string) => {
    try {
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "text/html",
        },
      });

      return response?.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const fetchDMSData = async (type: string, id: any) => {
    try {
      const queryObj: any = {};
      switch (type) {
        case "buyerOrgLogo":
          queryObj["moduleFileType"] = "org logo";
          queryObj["module"] = "orgs";
          queryObj["orgId"] = id;
          break;
        case "sellerOrgLogo":
          queryObj["moduleFileType"] = "org logo";
          queryObj["module"] = "orgs";
          queryObj["orgId"] = id;
          break;
        case "termsAndConditions":
          queryObj["moduleFileType"] = "termsAndConditions";
          queryObj["module"] = "invoice";
          queryObj["invoiceNumber"] = id;
          break;
        default:
          return;
      }
      const _response = await miscService.getByQuery(queryObj);
      const { status, response: dmsData } = _response;
      if (status && dmsData?.length > 0) {
        const item = dmsData[0];
        switch (type) {
          case "buyerOrgLogo":
            let orgLogo = item?.filePath;
            setOriginalData((pre: any) => ({ ...pre, buyerOrgLogo: orgLogo }));
            break;
          case "sellerOrgLogo":
            let sellerOrgLogo = item?.filePath;
            setOriginalData((pre: any) => ({
              ...pre,
              sellerOrgLogo: sellerOrgLogo,
            }));
            break;
          case "termsAndConditions":
            const _termsAndConditions: any = await fetchHtmlContentFromUrl(
              item?.filePath
            );
            setTermsAndConditions(_termsAndConditions);
            break;
          default:
            break;
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchCurrentUser();
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    const headerClick = () => setSm(false);
    document
      .getElementsByClassName("nk-header")[0]
      ?.addEventListener("click", headerClick);

    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
      document
        .getElementsByClassName("nk-header")[0]
        ?.removeEventListener("click", headerClick);
    };
  }, []);

  useEffect(() => {
    if (dispatchNumber) {
      setIsLoading(true);
      fetchDispatchData();
    }
  }, [dispatchNumber]);

  const ShowBillingAddress = ({ address }: any) => {
    if (!address) return <></>;
    const {
      deliveryLocationName,
      addressLine1,
      addressLine2,
      city,
      state,
      countryInfo,
      pincode,
      district,
    } = address;
    const { cin, gstin, pan, phoneNumber } = OriginalData?.orgDetails;
    return (
      <ul>
        <li>
          <strong style={{ color: "#2263b3" }}>
            {address?.deliveryLocationName}
          </strong>
        </li>
        <li>{addressLine1}</li>
        <li>{addressLine2}</li>
        <li>
          {city},{district}, {state}, {countryInfo} - {pincode}
        </li>
        <li>
          <strong>GSTIN</strong> : {gstin}
        </li>
        <li>
          <strong>CIN</strong> : {cin}
        </li>
        <li>
          <strong>PAN</strong> : {pan}
        </li>
        <li>
          <strong>Phone</strong> : {phoneNumber}
        </li>
      </ul>
    );
  };
  const ShowDeliveryAddress = ({ type, address }: any) => {
    if (!address) return <></>;
    const {
      deliveryLocationName,
      addressLine1,
      addressLine2,
      city,
      state,
      countryInfo,
      pincode,
      district,
    } = address;

    return (
      <ul>
        <li>
          <strong style={{ color: "#2263b3" }}>
            {address?.deliveryLocationName}
          </strong>
        </li>
        <li>
          {addressLine1},{addressLine2}
        </li>
        <li>
          {city},{district}, {state}, {countryInfo} - {pincode}
        </li>
        <li>
          <strong>Contact Person</strong> : {address?.contactPersonName}
        </li>
        <li>
          <strong>Mobile Number</strong> : {address?.mobileNumber}
        </li>
      </ul>
    );
  };

  function base64ToFile(base64String: string, fileName: string) {
    const byteString = atob(base64String.split(",")[1]);
    const mimeString = base64String.split(",")[0].split(":")[1].split(";")[0];
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uint8Array = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
      uint8Array[i] = byteString.charCodeAt(i);
    }

    const blob = new Blob([arrayBuffer], { type: mimeString });
    return new File([blob], fileName, { type: mimeString });
  }

  const acceptGRN = async (grnId: any, driverInfo: any) => {
    try {
      const rows = await form.validateFields();
      const dispatchLines: any = [];
      dataSource.forEach((item: any) => {
        const quantityDispatched = rows[`recievedQuantity_` + item.lineNo];
        dispatchLines.push({
          lineNo: item.lineNo,
          grnQuantity: quantityDispatched,
          grnStatus: "Accepted",
        });
      });
      const signatureLabel = invoiceSignature?.label;
      const _formData: any = new FormData();
      const filesData = [];
      const image = base64ToFile(invoiceSignature?.image, "signature.png");
      _formData.append("files", image);
      _formData.append("grnSignatureLabel", JSON.stringify(signatureLabel));
      _formData.append("dispatchLines", JSON.stringify(dispatchLines));
      _formData.append("driverInfo", JSON.stringify({
        vehicleType: driverInfo.vehicleType,
        vehicleNumber: driverInfo.vehicleNumber,
        inTime: driverInfo.inTime,
        name: driverInfo.driverName,
        mobile: driverInfo.driverContact,
        email: driverInfo.driverEmail
      }));

      filesData.push({
        indexOfFileLocated: filesData.length,
        module: "grn",
        purpose: "signature",
        level: "Header Level",
        uniqueId: nanoid(4),
        action: "Create",
      });
      _formData.append("filesData", JSON.stringify(filesData));
      const response = await dispatchApis.acceptGrn(
        dispatchNumber,
        grnId,
        _formData
      );
      const { status, message, error } = response;
      if (status) {
        Swal.fire("GRN Accepted", "", "success");
        navigate("/delivered-dispatch-list");
      } else {
        Swal.fire("Failed!", error + " : " + message, "error");
      }
    } catch (error) {
      console.log(error);
    }
    setDisableAccept(false);
  };

  const ShowSupplierBankInfo = () => {
    if (!OriginalData?.supplierDetails) return <></>;

    const { cin, gstin, pan, phoneNumber, bankDetails, address } =
      OriginalData?.supplierDetails || {};

    const { bankName, accountNumber, accountHolderName, branch, ifscCode } =
      bankDetails || {};

    const { city, stateInfo, countryInfo, pincode } = address || {};

    return (
      <Descriptions
        title="Supplier Bank Details "
        bordered
        column={1}
        size="small"
      >
        <Descriptions.Item label="GSTIN">{gstin}</Descriptions.Item>
        <Descriptions.Item label="CIN">{cin}</Descriptions.Item>
        <Descriptions.Item label="PAN">{pan}</Descriptions.Item>
        <Descriptions.Item label="Phone">{phoneNumber}</Descriptions.Item>
        <Descriptions.Item label="Bank Name">{bankName}</Descriptions.Item>
        <Descriptions.Item label="Account Number">
          {accountNumber}
        </Descriptions.Item>
        <Descriptions.Item label="Company Account Name">
          {accountHolderName}
        </Descriptions.Item>
        <Descriptions.Item label="Branch">{branch}</Descriptions.Item>
        <Descriptions.Item label="IFSC Code">{ifscCode}</Descriptions.Item>
        <Descriptions.Item label="City">{city}</Descriptions.Item>
        <Descriptions.Item label="State">
          {stateInfo?.stateName}
        </Descriptions.Item>
        <Descriptions.Item label="Country">
          {countryInfo?.countryName}
        </Descriptions.Item>
        <Descriptions.Item label="Pincode">{pincode}</Descriptions.Item>
      </Descriptions>
    );
  };

  const returnBillingDetails = () => {
    if (!OriginalData?.billingAddress) {
      return {};
    }
    const {
      deliveryLocationName,
      addressLine1,
      addressLine2,
      city,
      state,
      countryInfo,
      pincode,
      district,
    } = OriginalData?.billingAddress;
    const { cin, gstin, pan } = OriginalData?.orgDetails || {};
    return {
      name: OriginalData?.orgName || "",
      addressLine1: addressLine1,
      addressLine2: addressLine2,
      city: city,
      state: state,
      pincode: pincode,
      country: countryInfo,
      gstin: gstin || "",
      pan: pan || "",
      cin: cin || "",
      contactPersonName:
        OriginalData?.deliveryAddress?.contactPersonName || "N/A",
      mobileNumber: OriginalData?.deliveryAddress?.mobileNumber || "N/A",
    };
  };

  const returnSupplierDetails = () => {
    if (!OriginalData?.supplierDetails) {
      return {};
    }
    const { cin, gstin, pan, phoneNumber, bankDetails, address } =
      OriginalData?.supplierDetails || {};

    const { bankName, accountNumber, accountHolderName, branch, ifscCode } =
      bankDetails || {};

    const {
      city,
      stateInfo,
      countryInfo,
      pincode,
      addressline1,
      addressline2,
    } = address || {};
    return {
      name: OriginalData?.supplierName || "",
      addressLine1: addressline1 || "",
      addressLine2: addressline2 || "",
      city: city || "",
      state: stateInfo?.stateName || "",
      pincode: pincode || "",
      country: countryInfo?.countryName || "",
      gstin: gstin || "",
      pan: pan || "",
      cin: cin || "",
    };
  };
  const returnDispatchDetails = () => {
    let deliveryAddressString = "";
    if (
      OriginalData?.deliveryAddressType != "Line Level" &&
      OriginalData?.deliveryAddress
    ) {
      const {
        deliveryLocationName,
        addressLine1,
        addressLine2,
        city,
        state,
        countryInfo,
        pincode,
        district,
      } = OriginalData?.deliveryAddress;
      deliveryAddressString = [
        deliveryLocationName,
        addressLine1,
        addressLine2,
        city + ", " + state + ", " + district,
        countryInfo + ", " + pincode,
      ]
        ?.filter(Boolean)
        .join("\n");
    } else {
      deliveryAddressString = "Line Level";
    }
    const { driverInfo } = OriginalData;
    return {
      invoiceNumber: OriginalData?.invoiceId,
      invoiceDate: dayjs(OriginalData?.invoiceDate).format("DD-MMM-YYYY"),

      terms:
        materialData?.paymentTerms +
        (materialData?.advancePercentage
          ? `(${materialData?.advancePercentage}%)`
          : ""),
      customSONumber: "",
      ewayBillNumber: OriginalData?.ewbNo || "",
      placeofSupply: OriginalData?.deliveryAddress?.city || "",
      creditDays:
        materialData?.paymentTerms != "Cash and Carry"
          ? materialData?.creditDays
          : 0,
      deliveryAddressString,
      vehicleRefNo: driverInfo?.vehicleNumber || "",
      transporterName: driverInfo?.name || "",
      orderNumber: OriginalData?.orderId,
      orderDate: dayjs(OriginalData?.orderDate).format("DD-MMM-YYYY"),
      driverNumber: driverInfo?.mobile || "",

      totals: {
        taxableAmount: formatDecimal(materialData?.netAmount),
        cgst: formatDecimal(materialData?.cgst),
        sgst: formatDecimal(materialData?.sgst),
        igst: formatDecimal(materialData?.igst),
        total: formatDecimal(materialData?.grossTotal),
      },
      lines: dataSource?.map((item: any, index: any) => {
        let itemDescription = item?.materialName;
        if (item?.description) {
          itemDescription += "\t" + item?.description;
        }
        let deliveryAddressString = "";
        if (
          OriginalData?.deliveryAddressType == "Line Level" &&
          item?.deliveryAddress
        ) {
          const {
            deliveryLocationName,
            addressLine1,
            addressLine2,
            city,
            state,
            countryInfo,
            pincode,
            district,
          } = OriginalData?.deliveryAddress;
          deliveryAddressString = [
            deliveryLocationName,
            addressLine1,
            addressLine2,
            city,
            state,
            countryInfo,
            pincode,
            district,
          ]
            ?.filter(Boolean)
            .join(",");
          itemDescription += "\n\nDelivery Address: " + deliveryAddressString;
        }

        return {
          sno: index + 1,
          itemDescription,
          hsnSac: item?.hsnCode || "",
          rate: formatDecimal(item?.unitPrice),
          cgstPercentage: Number(item?.cgstPercentage),
          cgstAmount: formatDecimal(item?.cgst),
          sgstPercentage: Number(item?.sgstPercentage),
          sgstAmount: formatDecimal(item?.sgst),
          igstPercentage: Number(item?.igstPercentage),
          igstAmount: formatDecimal(item?.igst),
          taxableAmount: formatDecimal(item?.grossTotal),
          qty: Number(item?.quantityInvoiced),
          uom: item?.uomName,
        };
      }),
    };
  };

  return (
    <div className="card-inner card-inner-lg">
      {sm && mobileView && (
        <div className="toggle-overlay" onClick={() => setSm(!sm)}></div>
      )}
      <BlockHead size="lg">
        <BlockBetween>
          <BlockHeadContent>
            <BlockTitle tag="h4">
              <span>
                {OriginalData?.orderId} |{OriginalData?.invoiceId} |{" "}
                {OriginalData?.dispatchId}
              </span>
            </BlockTitle>
          </BlockHeadContent>

          <div className=" d-flex">
            {["Pending"].includes(OriginalData?.grnStatus) ? (
              <div className="actions clearfix">
                <ul
                  className="m-auto d-flex align-items-center justify-content-center p-0"
                  style={{
                    flexDirection: "row-reverse",
                  }}
                >
                  <li className="pt-0 pb-0">
                    {disableAccept ? (
                      <Button color="success" type="button">
                        <Spinner size="sm" color="light" />
                      </Button>
                    ) : (
                      <Button
                        // color="success"
                        style={{
                          backgroundColor: "#046200",
                          borderColor: "#046200",
                        }}
                        type="button"
                        onClick={() => {
                          if (!invoiceSignature?.image) {
                            Swal.fire(
                              "Error",
                              "Signature is required",
                              "error"
                            );
                            return;
                          }
                          setDisableAccept(true);
                          Swal.fire({
                            title: "Are you sure?",
                            text: "You won't be able to revert this!",
                            icon: "warning",
                            showCancelButton: true,
                          }).then((result) => {
                            if (result.isConfirmed) {

                              setIsModalVisible(true);
                            } else {
                              setDisableAccept(false);
                            }
                          });
                        }}
                      >
                        Received
                      </Button>
                    )}
                  </li>
                </ul>
              </div>
            ) : (
              <li className="pt-0 pb-0">
                <Dropdown
                  isOpen={shareOptionsToggle}
                  toggle={() => {
                    setShareOptionsToggle(!shareOptionsToggle);
                  }}
                >
                  <DropdownToggle className="btn btn-white btn-outline-light">
                    <Icon name="share"></Icon>
                    <span>Send</span>
                  </DropdownToggle>
                  <DropdownMenu>
                    {/* <DropdownItem onClick={() => {}}>
                                    <Icon name="archive"></Icon>
                                    <span>Send SMS</span>
                                  </DropdownItem> */}
                    <DropdownItem
                      onClick={() => {
                        setShowEmailModal(true);
                      }}
                    >
                      <Icon name="mail"></Icon>
                      <span>Send Mail</span>
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </li>
            )}
            {
              <div className="paddingLeft10">
                <ul className="m-auto d-flex align-items-center justify-content-center p-0">
                  <li className="pt-0 pb-0">
                    <PdfGenerator
                      orgDetails1={returnSupplierDetails()}
                      orgDetails2={returnBillingDetails()}
                      HeaderDetails={returnDispatchDetails()}
                      buyerOrgLogo={OriginalData?.sellerOrgLogo}
                      hasIGST={Number(materialData?.igst) != 0}
                      TermsAndConditions={termsAndConditions}
                    />
                  </li>
                  <li className="pt-0 pb-0">
                    <Button
                      className="toggle"
                      color="primary"
                      onClick={async () => {
                        navigate(previousPath, {
                          state: { ...extra?.previousState },
                        });
                      }}
                    >
                      <Icon name="arrow-left" />
                      <span>Back</span>
                    </Button>
                  </li>
                </ul>
              </div>
            }
          </div>
        </BlockBetween>
      </BlockHead>
      {isLoading == true ? (
        <>
          <Flex align="center" gap="middle" className="pageLoader">
            <Spin size="large" className="m-auto" />
          </Flex>
        </>
      ) : (
        <div className="content clearfix">
          <ApproveCN
            isModalVisible={isModalVisible}
            setIsModalVisible={setIsModalVisible}
            accept={acceptGRN}
            extra={{
              showGrnId: sequenceAccess?.includes("GRN") ? false : true
            }}
            originalData={OriginalData}
          />
          <AntCollapse defaultActiveKey={["1", "2", "3"]}>
            <Panel header="Driver Information" key="1">
              <div className="tab-content mt-0">
                <div className={`tab-pane${tab === "1" && " active"}`}>
                  <Col className="justify-start w-100  flex-wrap  p-0">
                    <div className="w-40 p-1 pt-0 pb-0 border-end">
                      <div className="data-col align-center p-0 pt-1">
                        <div className="data-label w-40">Vehicle Type</div>
                        <div className="data-value w-50">
                          <span>
                            {OriginalData?.driverInfo?.vehicleType || "N/A"}
                          </span>
                        </div>
                      </div>
                      <div className="data-col align-center p-0 pt-1">
                        <div className="data-label w-40">Vehicle Number</div>
                        <div className="data-value w-50">
                          <span>
                            {OriginalData?.driverInfo?.vehicleNumber || "N/A"}
                          </span>
                        </div>
                      </div>

                      <div className="data-col align-center p-0 pt-1">
                        <div className="data-label w-40">Driver Name</div>
                        <div className="data-value w-50">
                          <span>{OriginalData?.driverInfo?.name || "N/A"}</span>
                        </div>
                      </div>

                      <div className="data-col align-center p-0 pt-1">
                        <div className="data-label w-40">Email</div>
                        <div className="data-value w-50">
                          <span>
                            {OriginalData?.driverInfo?.email || "N/A"}
                          </span>
                        </div>
                      </div>
                      <div className="data-col align-center p-0 pt-1">
                        <div className="data-label w-40">Mobile</div>
                        <div className="data-value w-50">
                          <span>
                            {OriginalData?.driverInfo?.mobile || "N/A"}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="w-25  paddingLeft10 border-end">
                      <div className=" pt-0">
                        <div className="data-label w-90 mb-1">
                          Billing Address
                        </div>
                        <div className="data-value w-90">
                          <ShowBillingAddress
                            type="billing"
                            address={materialData?.billingAddress}
                          />
                        </div>
                      </div>
                    </div>
                    {materialData?.deliveryAddressId && (
                      <div className="w-35 paddingLeft10 ">
                        <div className=" pt-0">
                          <div className="data-label w-9 mb-1">
                            Delivery Address
                          </div>
                          <div className="data-value w-90">
                            <ShowDeliveryAddress
                              type="delivery"
                              address={materialData?.deliveryAddress}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </Col>
                </div>
              </div>
            </Panel>
            <Panel header="Material Information" key="2">
              <div
                className="table-responsive poTable"
                style={{ marginBottom: "20px" }}
              >
                <div
                  style={{
                    width: screenSize - (extra?.reduceTableWidth || 380) + "px",
                    margin: "0px auto",
                  }}
                >
                  <Form form={form} component={false}>
                    <Table
                      className="customTable"
                      components={{
                        body: {
                          cell: EditableCell,
                        },
                      }}
                      columns={mergedColumns.map((col: any) => {
                        if (col.key == "actions") {
                          return {
                            ...col,
                            hidden: readOnly,
                          };
                        }
                        return col;
                      })}
                      dataSource={dataSource.map((item: any) => ({
                        ...item,
                        quantityInvoiced: Number(item?.quantityInvoiced),
                        unitPrice: Number(item?.unitPrice),
                        key: item?.lineNo,
                      }))}
                      scroll={{ x: 1000 }}
                      expandable={{
                        expandedRowRender: (record: any) => (
                          <div className="expandableBody">
                            <div style={{ flex: 1, textAlign: "left" }}>
                              <p style={{ margin: 0 }}>{record.description}</p>
                              {record.file && (
                                <div>
                                  <PaperClipOutlined /> &nbsp;
                                  <a
                                    href={record?.file?.fileName}
                                    download={record?.file?.fileName}
                                  >
                                    {record?.file?.fileName}
                                  </a>
                                </div>
                              )}
                            </div>
                            {materialData?.deliveryAddressType ===
                              "Line Level" &&
                              record.deliveryAddressId && (
                                <div
                                  className="lineAddress"
                                  style={{ flex: 1 }}
                                >
                                  <h6>Delivery Address</h6>
                                  <ShowDeliveryAddress
                                    address={record.deliveryAddress}
                                  />
                                </div>
                              )}
                          </div>
                        ),
                      }}
                      bordered
                      size="middle"
                      pagination={false}
                    />
                  </Form>
                </div>
                {OriginalData?.grnId !== null && (
                  <Row className="m-4 justify-content-end ">
                    {signature?.isActive && (
                      <div className="signatureBtnWrapper">
                        <div className="d-flex justify-content-between align-items-center">
                          <strong>Signature</strong>
                        </div>
                        <div
                          style={{
                            minHeight: signature?.image ? "0px" : "120px",
                            display: signature?.image ? "block" : "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {signature?.image && (
                            <>
                              <div className="signatueImgWrapper border">
                                <img
                                  src={signature?.image}
                                  alt="Signed"
                                  style={{ width: "160px" }}
                                />
                              </div>

                              <div>
                                <div className="form-group">
                                  <label
                                    className="form-label"
                                    htmlFor="signatureLabel"
                                  >
                                    Signature Label
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="signatureLabel"
                                    onChange={(e) => { }}
                                    disabled
                                    defaultValue={
                                      signature?.label || "Authorised Signatory"
                                    }
                                  />
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    )}
                  </Row>
                )}
              </div>
              {OriginalData?.grnId == null && (
                <Row className="m-4 justify-content-end ">
                  {invoiceSignature?.isActive ? (
                    <div className="signatureBtnWrapper">
                      <div className="d-flex justify-content-between align-items-center">
                        <strong>Signature</strong>
                        <a
                          style={{
                            fontSize: "14px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setInvoiceSignature((prev: any) => ({
                              ...prev,
                              isActive: false,
                              image: null,
                              label: "Authorised Signatory",
                            }));
                            setValue("signatureObj", {
                              isActive: false,
                              image: null,
                              label: "Authorised Signatory",
                            });
                          }}
                        >
                          <Icon
                            name="cross"
                            className="pointer"
                            onClick={() => {
                              setInvoiceSignature((prev: any) => ({
                                ...prev,
                                isActive: false,
                                image: null,
                                label: "Authorised Signatory",
                              }));
                              setValue("signatureObj", {
                                isActive: false,
                                image: null,
                                label: "Authorised Signatory",
                              });
                            }}
                          />
                        </a>
                      </div>
                      <div
                        style={{
                          minHeight: invoiceSignature?.image ? "0px" : "120px",
                          display: invoiceSignature?.image ? "block" : "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {!invoiceSignature?.image && (
                          <Button
                            color="btn-dim btn"
                            onClick={() => {
                              setShowCropModel(true);
                            }}
                          >
                            <Icon
                              name="upload-cloud"
                              className="pointer"
                              onClick={() => {
                                setShowCropModel(true);
                              }}
                            />
                            <span>Upload</span>
                          </Button>
                        )}
                        {invoiceSignature?.image && (
                          <>
                            <div className="signatueImgWrapper border">
                              <img
                                src={invoiceSignature?.image}
                                alt="Signed"
                                style={{ width: "160px" }}
                              />
                            </div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Button
                                color="btn-dim btn"
                                onClick={() => {
                                  setInvoiceSignature((pre: any) => {
                                    return { ...pre, image: null };
                                  });
                                }}
                              >
                                <span>Reset</span>
                                <Icon
                                  name="redo"
                                  className="pointer"
                                  onClick={() => {
                                    setInvoiceSignature((pre: any) => {
                                      return {
                                        ...pre,
                                        image: null,
                                      };
                                    });
                                  }}
                                />
                              </Button>
                            </div>
                            <div>
                              <div className="form-group">
                                <label
                                  className="form-label"
                                  htmlFor="signatureLabel"
                                >
                                  Signature Label
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="signatureLabel"
                                  onChange={(e) => {
                                    setInvoiceSignature((pre: any) => {
                                      return {
                                        ...pre,
                                        label: e.target.value,
                                      };
                                    });
                                  }}
                                  defaultValue={
                                    invoiceSignature?.label ||
                                    "Authorised Signatory"
                                  }
                                />
                              </div>
                            </div>
                          </>
                        )}
                      </div>

                      {!invoiceSignature?.image && (
                        <>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              flexDirection: "column",
                            }}
                          >
                            <Button
                              color="btn-dim btn"
                              onClick={() => setShowSignatureModel(true)}
                            >
                              <Icon name="pen" />
                              <span>Use Signature Pad</span>
                            </Button>
                          </div>
                        </>
                      )}
                    </div>
                  ) : (
                    <div
                      style={{
                        border: "1px solid #e5ecf7",
                        backgroundColor: "#f7faff",
                        padding: "10px",
                        marginLeft: "10px",
                        width: "22%",
                        borderRadius: "5px",
                        textAlign: "center",
                      }}
                    >
                      <Button
                        color="btn-dim btn"
                        onClick={() => {
                          setInvoiceSignature((pre: any) => {
                            return { ...pre, isActive: true };
                          });
                        }}
                      >
                        <Icon
                          name="edit"
                          className="pointer"
                          onClick={() => {
                            setInvoiceSignature((pre: any) => {
                              return { ...pre, isActive: true };
                            });
                          }}
                        />
                        <span>Add Signature</span>
                      </Button>
                    </div>
                  )}
                </Row>
              )}
            </Panel>
            <Panel header="Attachments" key="3">
              {attachments?.length > 0 && (
                <Descriptions.Item label="">
                  <div>
                    <div>
                      {attachments?.map((attachment: any, index: number) => (
                        <div
                          key={index}
                          className="w-100 d-flex justify-content-between"
                        >
                          <div>
                            <strong>{index + 1}.</strong>
                            &nbsp;
                            {attachment.name}
                            &nbsp; &nbsp; &nbsp; &nbsp;
                          </div>
                          <div>
                            <a
                              href={attachment.link}
                              download={attachment.link}
                              style={{
                                color: "black",
                                fontSize: "18px",
                              }}
                            >
                              <DownloadOutlined />
                            </a>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </Descriptions.Item>
              )}
              {attachments?.length == 0 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "200px",
                  }}
                >
                  <Empty description="No Attachments Available for the GRN" />
                </div>
              )}
            </Panel>
          </AntCollapse>

          {showCropModel && (
            <CropperComponent
              modal={showCropModel}
              toggle={() => setShowCropModel(!showCropModel)}
              onSave={(data: string) => {
                setInvoiceSignature((pre: any) => {
                  return { ...pre, image: data };
                });
                setShowCropModel(false);
              }}
            />
          )}
          {showSignatureModel && (
            <SignatureModal
              modal={showSignatureModel}
              toggle={() => setShowSignatureModel(!showSignatureModel)}
              onSave={(data: string) => {
                setInvoiceSignature((pre: any) => {
                  return { ...pre, image: data };
                });
                setShowSignatureModel(false);
              }}
            />
          )}

          {showEmailModal && (
            <EmailCreationModal
              modal={showEmailModal}
              toggle={() => setShowEmailModal(!showEmailModal)}
              sendEmail={TriggerEmail}
              body={
                <div className="w-100 p-2">
                  <div className="m-auto">
                    <img
                      src={currentUser?.orgLogo}
                      alt={currentUser?.orgName}
                      width="200"
                      style={{ marginTop: "20px" }}
                    />

                    <div style={{ backgroundColor: "#fff", padding: "15px" }}>
                      {/* <h2 style={{ color: "#2263b3" }}>
                        Goods Receipt Confirmation
                      </h2> */}
                      <p style={{ color: "#1ee0ac", fontSize: "20px" }}>
                        Dear {OriginalData?.supplierName},
                      </p>
                      <p>
                        We are pleased to confirm that the goods/services
                        related to your delivery have been received and
                        acknowledged through a Goods Receipt Note (GRN) with ID{" "}
                        <strong>{OriginalData?.dispatchId}</strong>
                      </p>

                      <p>
                        <strong>GRN Summary:</strong>
                      </p>
                      <p>
                        <strong>GRN Number:</strong> {OriginalData?.dispatchId}
                        <br />
                        <strong>GRN Date:</strong>{" "}
                        {dayjs(OriginalData?.dispatchDate)?.format(
                          "DD-MMM-YYYY"
                        )}
                        <br />
                        <strong>Order Number:</strong> {OriginalData?.orderId}
                        <br />
                        <strong>Delivery Address:</strong>{" "}
                        {returnDispatchDetails()?.deliveryAddressString}
                        <br />
                      </p>

                      <p>
                        Please review the attached GRN document for full
                        details. If there are any discrepancies or questions
                        regarding the receipt, reach out to us promptly at{" "}
                        <a href={`mailto:{${currentUser?.email}}}`}>
                          {currentUser?.email}
                        </a>
                        .
                      </p>

                      <p>
                        This is an automatically generated email. Please do not
                        reply directly to this email.
                      </p>
                    </div>
                    {/* <p
                      style={{
                        marginTop: "20px",
                        fontSize: "12px",
                        color: "#000",
                      }}
                    >
                      Copyright © {dayjs().format("DD-MMM-YYYY")} Procurex
                      Technologies PVT LTD. All rights reserved.
                    </p> */}
                  </div>
                </div>
              }
              defaultAttachments={Object.assign({}, pdfBlobData.current, {
                name: OriginalData?.dispatchId + ".pdf",
                type: "application/pdf",
              })}
            />
          )}

          <AntModal
            title={undefined}
            visible={bankDetailsVisible}
            footer={null}
            onCancel={() => {
              setBankDetailsVisible(false);
            }}
            width="60%"
            bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }}
          >
            <ShowSupplierBankInfo />
          </AntModal>
        </div>
      )}
    </div>
  );
}
const ApproveCN = ({ isModalVisible, setIsModalVisible, accept, extra, originalData }: any) => {
  const [form] = Form.useForm();
  const { showGrnId } = extra
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (isModalVisible && originalData?.driverInfo) {
      form.setFieldsValue({
        vehicleType: originalData.driverInfo.vehicleType,
        vehicleNumber: originalData.driverInfo.vehicleNumber,
        driverName: originalData.driverInfo.name,
        driverContact: originalData.driverInfo.mobile,
        driverEmail: originalData.driverInfo.email,
      });
    }
  }, [isModalVisible, originalData, form]);

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleOk = () => {
    setIsSubmitting(true);
    form
      .validateFields()
      .then((values) => {
        const grnId = values?.grnId || "";
        const driverInfo = {
          vehicleType: values.vehicleType,
          vehicleNumber: values.vehicleNumber,
          inTime: values.inTime,
          driverName: values.driverName,
          driverContact: values.driverContact,
          driverEmail: values.driverEmail
        };
        accept(grnId, driverInfo);
        form.resetFields();
        setIsModalVisible(false);
      })
      .catch((error) => {
        console.log("error", error);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };
  return (
    <Modal
      open={isModalVisible}
      footer={null}
      onCancel={handleCancel}
      width={1000}
    >
      <Form
        form={form}
        layout="vertical"
        name="acceptForm"
        className="mt-2"
      >
        <div className="d-flex flex-wrap justify-content-between">
          {showGrnId ? <Form.Item
            className="w-30"
            name="grnId"
            label="GRN Number"
            rules={[{ required: true, message: "Enter GRN Number" }]}
          >
            <Input placeholder="Enter GRN Number" />
          </Form.Item> : <Form.Item
            className="w-30"
            name="driverEmail"
            label="Driver Email"
            rules={[
              {
                type: "email",
                message: "Please enter a valid email address",
              },
            ]}
          >
            <Input placeholder="Driver Email" />
          </Form.Item>}

          <Form.Item
            className="w-30"
            name="vehicleType"
            label="Vehicle Type"
          >
            <Select placeholder="Select Vehicle Type">
              <Select.Option value="tipper truck">Tipper truck</Select.Option>
              <Select.Option value="concrete truck">Concrete truck</Select.Option>
              <Select.Option value="pickup truck">Pickup truck</Select.Option>
              <Select.Option value="small truck">Small truck</Select.Option>
              <Select.Option value="box truck">Box truck</Select.Option>
              <Select.Option value="boat haulage">Boat haulage</Select.Option>
              <Select.Option value="flatbed truck">Flatbed truck</Select.Option>
              <Select.Option value="tow truck">Tow truck</Select.Option>
              <Select.Option value="chiller truck or reefers">Chiller truck or reefers</Select.Option>
              <Select.Option value="crane trucks or mobile cranes">Crane trucks or mobile cranes</Select.Option>
              <Select.Option value="logging truck">Logging truck</Select.Option>
              <Select.Option value="tanker truck">Tanker truck</Select.Option>
              <Select.Option value="furniture truck">Furniture truck</Select.Option>
              <Select.Option value="snow plows">Snow plows</Select.Option>
              <Select.Option value="trailer Truck">Trailer Truck</Select.Option>
              <Select.Option value="off-road Truck">Off-road Truck</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item
            className="w-30"
            name="vehicleNumber"
            label="Vehicle Number"
            rules={[
              {
                required: true,
                message: "Please enter Vehicle Number",
              },
              {
                pattern: /^[A-Z]{2}\d{2}[A-Z]{1,2}\d{4}$/,
                message: "Format should be like MH12AB1234",
              },
            ]}
          >
            <Input placeholder="e.g. MH12AB1234" />
          </Form.Item>

        </div>
        <div className="d-flex flex-wrap justify-content-between">

          <Form.Item
            className="w-30"
            name="inTime"
            label="Vehicle In Time"
            rules={[
              {
                required: true,
                message: "Please enter Vehicle In Time",
              },
            ]}
          >
            <TimePicker use12Hours format="h:mm a" style={{ width: '100%' }} placeholder="Select Time" />
          </Form.Item>

          <Form.Item
            className="w-30"
            name="driverName"
            label="Driver Name"
            rules={[{ required: true, message: "Please enter Driver Name" }]}
          >
            <Input placeholder="Driver Name" />
          </Form.Item>

          <Form.Item
            className="w-30"
            name="driverContact"
            label="Driver Contact"
            rules={[
              {
                required: true,
                message: "Please enter Driver Contact",
              },
              {
                pattern: /^[0-9]{10}$/,
                message: "Should be a 10-digit number",
              },
            ]}
          >
            <Input placeholder="e.g. 9876543210" />
          </Form.Item>
        </div>
        {showGrnId ? <Form.Item
          className="w-50"
          name="driverEmail"
          label="Driver Email"
          rules={[
            {
              type: "email",
              message: "Please enter a valid email address",
            },
          ]}
        >
          <Input placeholder="Driver Email" />
        </Form.Item> : <></>}
        <div className="actions clearfix">
          <ul>
            <li>
              {isSubmitting ? (
                <Button color="primary" type="button">
                  <Spinner size="sm" color="light" />
                </Button>
              ) : (
                <Button color="primary" type="submit" onClick={handleOk}>
                  Submit
                </Button>
              )}
            </li>
            <li>
              <Button
                color="primary"
                onClick={handleCancel}
                className="btn-dim btn btn-secondary"
              >
                Cancel
              </Button>
            </li>
          </ul>
        </div>
      </Form>
    </Modal>
  );
};
export default DispatchComponent;
